import React from "react";
import mri_outline from "../../assets/images/about-page/mri_outline_1.png";
import AboutMRI from "../../assets/images/about-page/canon_ct_2.JPG";
export default function WhyWeAre() {
  return (
    <div className="pt-8 sm:pt-12  bg-[#ffffff]">
      <div className="flex justify-center items-center p-4 w-full ">
        <img src={mri_outline} alt="mri outline" className="object-cover" />
      </div>
      <div className="flex justify-center flex-col items-center bg-white">
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 xl:gap-10 2xl:gap-2 gap-2 2xl:pb-28 xl:py-24 lg:py-20 md:py-16 py-8 xl:px-16 2xl:px-0 text-[#d78558]">
          <div className="2xl:text-6xl xl:text-[2.75rem] text-4xl flex  lg:justify-start items-center justify-center md:text-left text-center font-bold mb-6 font-robout">
            <h3 data-aos="fade-up" data-aos-delay="100">
              What we do
            </h3>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="xl:text-[1.5rem] md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 leading-normal lg:text-left text-center text-[#1d1d1f] font-robout"
          >
            <p>
              As an ACR Accredited Diagnostic Centre, CDC endorse the highest
              standards of quality and safety in medical imaging and
              diagnostics. We follow the “As Low As Reasonably Achievable ”
              principle for radiology safety while also providing advanced
              laboratory services and preventive health checkups. With
              cutting-edge technology and expert professionals, we deliver fast,
              accurate, and dependable results to support better treatment
              decisions.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center bg-white">
        <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 grid-cols-1 xl:gap-10 2xl:gap-2 gap-2 2xl:pb-28 xl:pb-24 lg:pb-20 md:pb-16 pb-8 xl:px-16 2xl:px-0 text-[#d78558]">
          <div className="2xl:text-6xl xl:text-[2.75rem] text-4xl flex lg:justify-start justify-center items-center md:text-left text-center font-bold mb-6 font-robout">
            <h3 data-aos="fade-up" data-aos-delay="100">
              Our Promise
            </h3>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="xl:text-[1.5rem] md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 text-[#1d1d1f] leading-normal lg:text-left text-center font-robout"
          >
            <p>
              From the moment you walk through our doors, we treat your care as
              our highest priority. Our radiologists are hands-on throughout the
              process, ensuring every image meets the highest standards of
              clarity and accuracy.
            </p>
          </div>
        </div>
      </div>
      {/* <MarqueeText /> */}
      <div className="flex justify-center items-center  xl:p-16 lg:p-8 p-4 w-full bg-[#f9f9f9]">
        <img
          src={AboutMRI}
          alt="mri outline"
          className="object-cover rounded-3xl"
        />
      </div>
      <div className="flex justify-center items-center bg-white pt-12 lg:py-28">
        <div className="2xl:w-4/5 w-[90%] px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 2xl:px-0  mx-auto">
          <div className="2xl:text-6xl leading-10 xl:text-[2.75rem] pb-10 text-4xl text-center font-bold  font-robout">
            <h3 data-aos="fade-up" className="text-center text-[#d78558]">Care Beyond Diagnosis</h3>
          </div>
          <div className="grid lg:grid-cols-2 lg:mt-24 md:mt-12 ">
            <div className=" xl:text-[2.75rem] md:text-4xl text-2xl  flex  lg:pe-8 items-center justify-center lg:justify-start lg:text-left text-center font-bold mb-6 font-robout">
              <h3 data-aos="fade-up" className=" text-[#d78558]">Radiologist-Led Precision</h3>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              className="xl:text-[1.5rem] text-[#1d1d1f] md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 leading-normal lg:text-left text-center font-robout"
            >
              <p>
                Every scan at CDC is interpreted by highly skilled radiologists,
                ensuring not just images but clinical insights. Our reporting
                bridges the gap between diagnosis and the right course of
                treatment.
              </p>
            </div>
          </div>
          <div className="grid lg:grid-cols-2 my-12 lg:my-24">
            <div className=" xl:text-[2.75rem] md:text-4xl text-2xl  flex  lg:pe-8 items-center justify-center lg:justify-start lg:text-left text-center font-bold mb-6 font-robout">
              <h3 data-aos="fade-up" className=" text-[#d78558]">Seamless Patient Journey</h3>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              className="xl:text-[1.5rem] text-[#1d1d1f] md:text-[1.125rem] text-[1rem] lg:ps-0 md:px-8 px-2 leading-normal lg:text-left text-center font-robout"
            >
              <p>
                From scheduling your appointment to receiving your results, we
                make the process effortless. With transparent communication,
                compassionate support, and a smooth scanning experience, CDC
                ensures care that is as convenient as it is advanced.
              </p>
            </div>
          </div>
          <div className="grid lg:grid-cols-2 my-12 lg:my-24">
            <div className=" xl:text-[2.75rem] md:text-4xl text-2xl  flex  lg:pe-8 items-center justify-center lg:justify-start lg:text-left text-center font-bold mb-6 font-robout">
              <h3 data-aos="fade-up" className=" text-[#d78558]">Accurate Diagnosis</h3>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              className="xl:text-[1.5rem] text-[#1d1d1f] md:text-[1.125rem] text-[1rem] lg:ps-0 md:px-8 px-2 leading-normal lg:text-left text-center font-robout"
            >
              <p>
                With the most advanced scanning systems and state-of-the-art
                imaging software, we ensure the highest level of accuracy and
                reliability in every result.
              </p>
            </div>
          </div>
          <div className="grid lg:grid-cols-2 ">
            <div className=" xl:text-[2.75rem] md:text-4xl text-2xl  flex  lg:pe-8 items-center justify-center lg:justify-start lg:text-left text-center font-bold mb-6 font-robout">
              <h3 data-aos="fade-up" className=" text-[#d78558]">Swift & Accessible Reporting</h3>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              className="xl:text-[1.5rem] text-[#1d1d1f] md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 leading-normal lg:text-left text-center font-robout"
            >
              <p>
                Detailed reports are delivered within 24–48 hours, with minimal
                waiting and costs that remain significantly lower than hospital
                standards—making world-class radiology accessible to every
                patient.
              </p>
            </div>
          </div>
          <div className="text-center lg:pb-0 pb-12 pt-16 xl:text-[3rem] text-3xl flex leading-normal justify-center font-bold font-robout">
            <h3 className="w-[95%] capitalize text-[#d78558]" data-aos="fade-up" >
              Community-based radiology, academic-level expertise
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
